export default __webpack_public_path__ + "static/media/486-Series-High-Flow-Regulators.759537f6.jpg";